var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 2.58579 3.33578 2.25 3.75 2.25C4.16421 2.25 4.5 2.58579 4.5 3L4.5 21C4.5 21.4142 4.16421 21.75 3.74999 21.75C3.33578 21.75 2.99999 21.4142 2.99999 21L3 3ZM11.7803 6.96967C12.0732 7.26257 12.0732 7.73744 11.7803 8.03033L8.56065 11.25L21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75L8.56066 12.75L11.7803 15.9697C12.0732 16.2626 12.0732 16.7374 11.7803 17.0303C11.4874 17.3232 11.0126 17.3232 10.7197 17.0303L6.21966 12.5303C5.92677 12.2374 5.92677 11.7626 6.21966 11.4697L10.7197 6.96967C11.0126 6.67678 11.4874 6.67678 11.7803 6.96967Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.64fd6061b0ee160d0805a888a1e89848.svg";
export { ForwardRef as ReactComponent };